








































































import { Component, Vue } from 'vue-property-decorator'
import Nav from './../Business/pages/components/Navs.vue'

import {
  currentUserBalance,
  getCurrentUserAccount,
  currentUserWithdrawals
  // findBalanceByCurrentUser
} from '@/api/transaction'

interface bankListType {
  id: number,
  code: string,
  logo: string
}
interface info {
  accountBalance?: string | number,
  accountWithdraw?: string | number,
  [propName: string]: any
}
interface logoMap {
  [propName: number]: any
}
@Component({
  name: 'Cash',
  components: {
    Nav
  }
})
export default class Cash extends Vue {
  // 提交参数
  private params = {
    money: '',
    code: '',
    payServiceId: 0
  }

  private navBarList = [
    {
      name: '全球货仓代收代付(提现)',
      path: `/cash/withdrawRecord?currency=${this.$route.query.currency}&typeId=1`
    }, {
      name: '商户中心',
      path: '/business/info'
    }
  ]

  symbol: string = this.$route.query.symbol as string || ''

  currency: string = this.$route.query.currency as string || ''

  info: info = {}

  private withdrawFee = 0

  logoMap: logoMap = {
    10002: require('@/assets/zfb.png'),
    10004: require('@/assets/bank.png')
  }

  bankList: Array<bankListType> = []

  active: string | number = 1

  async init () {
    this.currentUserBalance()
    const res = await getCurrentUserAccount({
      currencyCode: this.currency
    })
    this.bankList = res
    if (this.bankList.length) {
      this.choose(this.bankList[0].id, this.bankList[0].code)
    }
    console.log(res, 1234)
  }

  async currentUserBalance () {
    const res = await currentUserBalance()
    const arr = res.filter(e => {
      return e.currencyCode === this.currency
    })
    this.info = arr[0]
  }

  submit (): void {
    if (!this.params.money) return
    if (Number(this.params.money) > (Number(this.info.accountWithdraw) / 100)) return
    (this.$refs.form as any).validate(async (field) => {
      if (!field) return
      const params = { ...this.params } as any
      params.currencyCode = this.currency
      params.money = Number(params.money)
      const loading = this.$loading({
        lock: true,
        text: '提现中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const res = await currentUserWithdrawals(params)
      console.log(res, 112233)
      loading.close()
      if (!res.success) {
        this.$message.error(res.msg || '提现失败')
        return
      }
      this.$message.success(res.msg || '提现成功')
      this.init()
    })
  }

  choose (id: number, code: string): void {
    console.log(code)
    this.params.payServiceId = id
    this.params.code = code
  }

  changeType (type): void {
    this.active = type
  }

  // getFindBalanceByCurrentUser () {
  //   findBalanceByCurrentUser({
  //     currencyCode: 'CNY'
  //   })
  //     .then(res => {
  //       console.log(res)
  //     })
  // }

  created () {
    this.withdrawFee = this.$store.state.User.userInfo.withdrawFee
    this.init()
    // this.getFindBalanceByCurrentUser()
  }
}

